import styled, { css } from 'styled-components';

export const GreetingBanner = styled.div`
  ${({ theme, size }) => css`
    background: linear-gradient(90deg, #0070D1 0%, #0070D1 6.25%, #0271D2 12.5%, #0473D3 18.75%, #0775D4 25%, #0B78D5 31.25%, #107BD7 37.5%, #1680DA 43.75%, #1D84DC 50%, #258AE0 56.25%, #2D90E3 62.5%, #3796E7 68.75%, #419EEB 75%, #4DA5EF 81.25%, #59AEF4 87.5%, #66B7F9 93.75%, #74C1FF 100%);
    color: ${theme.v2.colors.neutral.highPure};
    font-family: ${theme.v2.font.family.primary};
    padding: 20px;
    position: relative;
    width: ${`${size}%` || '100%'};
    
    @media (min-width: ${theme.v2.breakpoints.md}) {
      padding: 33px 40px;
      border-radius: 16px;
      width: 100%;
    }
  `}
`;

export const GreetingBannerTitle = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const GreetingBannerSubtitle = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const WrapperButton = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.neutral.highPure};
    border-radius: 99px;
    white-space: nowrap;
  `}
`;

export const Row = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 10px;
    justify-content: space-between;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      align-items: center;
    }
  `}
`;

export const Column = styled.div`
  position: relative;
`;

export const SkeletonWrapper = styled.div`
  ${({ theme, size }) => css`
    align-items: center;
    background: ${theme.v2.colors.neutral.highPure};
    border-radius: 0;
    display: flex;
    gap: 20px;
    justify-content: space-between;
    padding: 20px;
    width: ${`calc(${size || 100}% - ${!size || size === 100 ? '0px' : '8px'})`};

    @media (min-width: ${theme.v2.breakpoints.md}) {
      padding: 33px 40px;
      border-radius: 16px;
    }
  `}
`;
